export enum TooltipBiButtonId {
  DealerOfferTooltipCTA = 'dealer_offer_tooltip_open_widget',
}
